import React from 'react'
import { LogoColor, LogoColorType } from 'types/types'
import { BvnkLogo } from './BvnkLogo'

interface LogoProps {
  logoColor?: LogoColorType
  isSmall?: boolean
}

export const Logo = ({ logoColor = LogoColor.LIGHT, isSmall }: LogoProps) => {
  return <BvnkLogo color={logoColor} {...(isSmall && { width: 53, height: 16 })} />
}
